// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import { spacing, mediaMax, fontWeight } from 'presentations/views/styles';
import { gray02, gray04 } from 'presentations/views/styles/color';
import TextField from 'presentations/views/components/atoms/TextField';
import Button from 'presentations/views/components/atoms/Button';
import { ErrorList } from 'domains/models';

interface Props {
  hasSocialLoginProvider?: boolean;
  isLoading?: boolean;
  isLogin: boolean;
  email: string | null;
  password: string | null;
  onChange?: any;
  onSubmit?: any;
  errors: ErrorList;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const buttonLabel = props.isLogin ? 'login' : 'sign up';
  const description = `${buttonLabel} description`;
  let canSubmit = false;
  if (props.password && !Object.keys(props.errors).length) {
    canSubmit = true;
  }

  return (
    <form onSubmit={props.onSubmit}>
      <Container>
        {(!props.isLogin || props.hasSocialLoginProvider) && (
          <TextOther>OR</TextOther>
        )}
        <Text>{t(description)}</Text>
        {!props.isLogin && <Email>{props.email}</Email>}
        <FormContainer>
          <FormField>
            <TextField
              type="password"
              name="password"
              placeholder={t('password')}
              value={props.password}
              onChange={props.onChange}
              isDisabled={props.isLoading}
              width={300}
              errors={props.errors['password'] || []}
            />
          </FormField>
        </FormContainer>
        <SubmitContainer>
          <SubmitButton
            type="submit"
            size="large"
            color="primary"
            isLoading={props.isLoading}
            isDisabled={!canSubmit}
          >
            {t(buttonLabel)}
          </SubmitButton>
        </SubmitContainer>
      </Container>
    </form>
  );
}

const Email = styled.div`
  margin-bottom: ${spacing(32)};
`;
const SubmitButton = styled(Button)`
  width: 300px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
const Text = styled.div`
  margin-bottom: ${spacing(24)};
  font-weight: ${fontWeight('bold')};
`;

const FormContainer = styled.div`
  margin-bottom: ${spacing(16)};
  width: 100%;
`;
const FormField = styled.div`
  margin-bottom: ${spacing(12)};
  width: 300px;

  ${mediaMax.smartphone} {
    width: 240px;
  }
  :last-of-type {
    margin-bottom: 0;
  }
  .MuiFormControl-root {
    width: 100%;
  }
`;

const SubmitContainer = styled.div`
  width: 100%;
  .MuiButtonBase-root {
    width: 100%;
  }
`;

const TextOther = styled.p`
  width: 100%;
  color: ${gray02};
  display: flex;
  align-items: center;
  margin-bottom: ${spacing(32)};

  &:before,
  &:after {
    content: '';
    flex-grow: 1;
    height: 1px;
    background: ${gray04};
    display: block;
  }
  &:before {
    margin-right: 1.4em;
  }
  &:after {
    margin-left: 1.4em;
  }
`;
